module.exports = __webpack_public_path__ + "img/e7e2d17.svg";